import { render, staticRenderFns } from "./CanteenStaff.vue?vue&type=template&id=4d678856&"
import script from "./CanteenStaff.vue?vue&type=script&lang=js&"
export * from "./CanteenStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports